export enum RefundableState {
  REFUNDABLE = 'Refundable',
  NON_REFUNDABLE = 'Non-Refundable',
  PARTIALLY_REFUNDABLE = 'Partially Refundable',
}
